import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { motion } from 'framer-motion';
import { useZoomHandler } from './hooks/use-zoom-handler';
import { ZoomControllerButtons } from './subcomponents/buttons';
const b = bemClassBuilder('v-zoom-controller');
const bViewport = bemClassBuilder('v-zoom-controller-viewport');
/**
 * Renders a ZoomController component that handles zooming and panning of a child element.
 * Supports mouse, keyboard and touch input.
 */
export const ZoomController = props => {
    const { className, contentDimensions, showPanButtons, showZoomButtons, zoomButtonsPosition, onScrollPositionChange, isDisabled } = props;
    const zoomHandler = useZoomHandler({
        contentDimensions,
        isDisabled,
        onScrollPositionChange
    });
    return (_jsxs("div", { className: b.block({ showPanButtons }, className), ref: zoomHandler.containerRef, tabIndex: 0, children: [_jsx("div", { className: bViewport.block(), ref: zoomHandler.viewportRef, children: _jsx("div", { className: bViewport.element('content-wrapper'), children: _jsx(motion.div, { className: bViewport.element('content'), ref: zoomHandler.contentRef, style: zoomHandler.contentStyles, children: props.children }) }) }), _jsx(ZoomControllerButtons, { handler: zoomHandler, showPanButtons: showPanButtons, showZoomButtons: showZoomButtons, zoomButtonsPosition: zoomButtonsPosition, isDisabled: isDisabled })] }));
};
ZoomController.displayName = 'ZoomController';
//# sourceMappingURL=zoom-controller.js.map